var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDefaultSkeletonMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 335 924"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#default-skeleton-mobile_svg__b)",
  clipPath: "url(#default-skeleton-mobile_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  y: 74,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 266,
  y: 156,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 266,
  y: 454,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 752,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 797.5,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 843,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 888.5,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "default-skeleton-mobile_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "default-skeleton-mobile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h335v924H0z"
})))));
export { SvgDefaultSkeletonMobile as ReactComponent };
export default __webpack_public_path__ + "static/media/default-skeleton-mobile.2c9578fbe00db0718986.svg";